import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppContext } from "../contexts/AppContext";
import { updateProfile, getuserInfo } from "../store/actions/userActions";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "./const.prop";

const AddAbout = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  const [aboutInfo, setAboutInfo] = useState("");

  useEffect(() => {
    if (userData && userData?.about) {
      setAboutInfo(userData?.about);
    }
  }, [userData]);

  const successCallback = () => {
    dispatch(getuserInfo());
    // appContext.updateNotificationState({
    //   type: "success",
    //   message: "About updated successfully",
    //   show: true,
    // });
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const handleSubmit = () => {
    appContext.updateLoaderState(true);
    dispatch(
      updateProfile(
        {
          about: aboutInfo,
        },
        successCallback,
        failureCallback
      )
    );
  };

  return (
    <>
      <div className="modal-body">
        <div className="form-group input-group">
          <label className="has-float-label">
            <textarea
              className="form-control"
              rows="5"
              id="comment"
              style={{ background: "#F3F4F6" }}
              value={aboutInfo}
              onChange={(e) => setAboutInfo(e.target.value)}
            />
          </label>
        </div>
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={handleSubmit}
        >
          Done
        </button>
      </div>
    </>
  );
};

export default AddAbout;
